import React from 'react';

const SvgCommunication10 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M17 12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-.34a.46.46 0 0 1 .11-.3L6 8.19A.52.52 0 0 1 6.35 8a.5.5 0 0 1 .39.18l1.45 1.75a.49.49 0 0 0 .38.18.51.51 0 0 0 .4-.2l2.88-3.72a.51.51 0 0 1 .8 0l4.25 5.67a.51.51 0 0 1 .1.3zM7.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5.09a1 1 0 0 1 .7.29l1.49 1.49c.14.14.331.22.53.22h.38a.75.75 0 0 0 .53-.22l1.49-1.49a1 1 0 0 1 .7-.29H18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgCommunication10 svgRef={ref} {...props} />);
export default ForwardRef;
